import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { SMS_NOTIFICATION_ACTION_TYPE } from "./sms-notification-settings.action";
import { SmsNotificationSettingsState } from "./sms-notification-settings.model";

const INITIAL_STATE: SmsNotificationSettingsState = {};

/**
 * @deprecated - [fabric-deprecated] - Use SmsNotificationSettingsService from app-account mfe instead
 */
export function smsNotificationSettingsReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): SmsNotificationSettingsState {
	switch (action.type) {
		case SMS_NOTIFICATION_ACTION_TYPE.getAllSuccess:
		case SMS_NOTIFICATION_ACTION_TYPE.updateSuccess: {
			return updateState(state, {
				settings: action.payload,
			});
		}
		default:
			return state;
	}
}
